import React from 'react';
import CustomPortal from "../../CustomPortal";
import VerifyConfirmationCode from '../../registration-component/VerifyConfirmationCode';

const EmailConfirmationForm = () => {
  return (
    <CustomPortal
        header="Please check your email and input the activation code"
        Component={VerifyConfirmationCode}
    />
  );
}

export default EmailConfirmationForm;